import React from "react";
import Navbar from "../HomePage/Navbar/Navbar";
import NavbarD from "../HomePage/Navbar/NavbarD";
import Footer from "../HomePage/Footer/Footer";
import { useLanguage } from "../../context/LanguageContext";

import policyDataEn from "../../languages/en/policyData";
import policyDataTh from "../../languages/th/policyData";
const Policy = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  console.log(selectedLanguage);
  const policyData = selectedLanguage === "en" ? policyDataEn : policyDataTh;

  if (!policyData || Object.keys(policyData).length === 0) {
    return <div>No policy data available.</div>;
  }

  return (
    <>
      <div className="lg:hidden">
        <Navbar theme="black" />
      </div>
      <div className="hidden md:hidden lg:block">
        <NavbarD theme="black" />
      </div>
      <div className="flex  flex-col mx-8 py-8 ">
        <h1 className="text-3xl text-center font-bold my-10 px-4">
          {policyData.title}
        </h1>

        <div className="px-4">
          <p className=" text-xs ">{policyData.subTitle}</p>

          <h4 className="text-xl font-bold mt-3">{policyData.heading1}</h4>

          <h4 className="text-lg font-medium mt-4">{policyData.heading2}</h4>
          <p className="mt-2">{policyData.paragraph}</p>
        </div>

        {policyData.data.map((policy, index) => (
          <div key={policy.id} className="mb-8">
            <h2 className="text-2xl font-bold mb-4">{`${index + 1}. ${
              policy.title
            }`}</h2>
            {policy.paragraphs &&
              policy.paragraphs.map((paragraph, index) => (
                <p key={index} className="mb-2">
                  {paragraph}
                </p>
              ))}
            {policy.subTitle1 && (
              <div className="ml-4">
                <h3 className="text-lg font-bold mb-2">{policy.subTitle1}</h3>
                {policy.content1 &&
                  policy.content1.map((content, index) => (
                    <p key={index} className="mb-2 ml-4">
                      {content}
                    </p>
                  ))}
                {policy.list1 && (
                  <ul className="list-disc list-inside ml-8">
                    {Object.keys(policy.list1).map((key) => (
                      <li key={key}>{policy.list1[key]}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            {policy.subTitle2 && (
              <div className="ml-4">
                <h3 className="text-lg font-bold mb-2">{policy.subTitle2}</h3>
                {policy.content2 &&
                  policy.content2.map((content, index) => (
                    <p key={index} className="mb-2 ml-4">
                      {content}
                    </p>
                  ))}
                {policy.list2 && (
                  <ul className="list-disc list-inside ml-8">
                    {Object.keys(policy.list2).map((key) => {
                      const listItem = policy.list2[key];
                      if (typeof listItem === "string") {
                        return <li key={key}>{listItem}</li>;
                      } else {
                        return (
                          <li key={key}>
                            <p className="mb-2">{listItem.title}</p>
                            {listItem.nestedList && (
                              <ul className="list-disc list-inside ml-8">
                                {Object.keys(listItem.nestedList).map(
                                  (nestedKey) => (
                                    <li key={nestedKey}>
                                      {listItem.nestedList[nestedKey]}
                                    </li>
                                  )
                                )}
                              </ul>
                            )}
                          </li>
                        );
                      }
                    })}
                  </ul>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      <Footer language={selectedLanguage} />
    </>
  );
};

export default Policy;
